var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sm-empty-mail"},[_c('include-svg',{attrs:{"name":("icon-empty-" + _vm.icon)}}),_c('h5',[_vm._v("Nothing here yet")]),_c('p',[_vm._v(_vm._s(_vm.texts[_vm.tab]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }